/* ──────────────────────────────
   store/tag/action.js
   ────────────────────────────── */
import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  GET_TAGS, ADD_TAG, UPDATE_TAG, DELETE_TAG
} from "./types";

export const getTags = () => async (dispatch) => {
  try {
    const { data } = await axios.get("/tag/tags");   // <-- FIXED

    if (data.status) {
      const sorted = data.tags.sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );

      dispatch({
        type: GET_TAGS,
        payload: { tags: sorted, total: sorted.length },
      });
    } else {
      Toast("error", data.message);
    }
  } catch (err) {
    Toast("error", err.message);
  }
};

export const createTag = (formData) => (dispatch) => {
  axios
    .post("/tag/tags", formData)   // <-- FIXED
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ADD_TAG, payload: res.data.tag });
        Toast("success", "Tag created!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((err) => Toast("error", err.message));
};

export const updateTag = (tagId, formData) => (dispatch) => {
  axios
    .patch(`/tag/tags/${tagId}`, formData)   // <-- FIXED
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: UPDATE_TAG, payload: res.data.tag });
        Toast("success", "Tag updated!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((err) => Toast("error", err.message));
};

export const deleteTag = (tagId) => (dispatch) => {
  axios
    .delete(`/tag/tags/${tagId}`)   // <-- FIXED
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: DELETE_TAG, payload: tagId });
        Toast("success", "Tag deleted!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((err) => Toast("error", err.message));
};
